import styled from 'styled-components';
import { StyledTopicItem } from 'routes/Home/PopularTopics/styles';

export const StyledQuickRepliesWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing['2Xl']};
  margin-bottom: ${({ theme }) => theme.spacing['xs']}; // room for box-shadow/border
  text-align: start;
`;

export const StyledContentWrapper = styled.div`
  width: 100%;
  text-align: start;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing['md']};
`;

export const StyledQuickReplyOption = styled(StyledTopicItem)``;

export const StyledQuickRepliesTitle = styled.div`
  text-align: left;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;
